// comes from enum VehicleType in queries-processed
export enum EVehicleType {
  TRACTOR = 'TRACTOR',
  TRAILER = 'TRAILER',
  BOX = 'BOX',
  FRIGO = 'FRIGO',
  TRUCK = 'TRUCK',
  VAN = 'VAN',
  MEGA = 'MEGA',
  SMALL_TRAILER = 'SMALL_TRAILER',
  MEGA_TRAILER = 'MEGA_TRAILER',
  DUO_TRAILER = 'DUO_TRAILER',
  GAS = 'GAS',
  GAS_CARRIER = 'GAS_CARRIER',
  BIODIESEL = 'BIODIESEL',
  BIODIESEL_CARRIER = 'BIODIESEL_CARRIER',
  TRAIN = 'TRAIN',
  TRAIN_CARRIER = 'TRAIN_CARRIER',
  EXCLUDED_CARRIER = 'EXCLUDED_CARRIER',
  RIGID = 'RIGID',
  CANVAS = 'CANVAS',
  MOBILE_CANVAS = 'MOBILE_CANVAS',
  RIGID_TRUCK = 'RIGID_TRUCK',
  RIGID_CANVAS = 'RIGID_CANVAS',
  REFRIGERATED = 'REFRIGERATED',
  RIGID_REFRIGERATED = 'RIGID_REFRIGERATED',
  BIREFRIGERATED = 'BIREFRIGERATED',
  TRIREFRIGERATED = 'TRIREFRIGERATED',
  BULK = 'BULK',
  DUMP = 'DUMP',
  TANKER = 'TANKER',
  REFRIGERATED_TANKER = 'REFRIGERATED_TANKER',
  CRANE = 'CRANE',
  JUMBO_TRAILER = 'JUMBO_TRAILER',
  OTHER = 'OTHER',
}
